import { NgModule } from '@angular/core';
import { LayoutComponent } from 'app/layout/layout.component';
import { MaterialLayoutModule } from 'app/layout/layouts/horizontal/material/material.module';
import { SharedModule } from 'app/shared/shared.module';
import { EmptyLayoutModule } from 'app/layout/layouts/empty/empty.module';
import { FullWidthLayoutModule } from 'app/layout/layouts/full-width/full-width.module';

const layoutModules = [
    EmptyLayoutModule,
    // Horizontal navigation
    MaterialLayoutModule,
    FullWidthLayoutModule
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports     : [
        SharedModule,
        ...layoutModules
    ],
    exports     : [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule
{
}
